import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../lib/request";

/**
 * ================================
 * APPROVE FROM EMAIL (PUBLIC - TOKEN BASED)
 * ================================
 */
export const approveFromEmail = createAsyncThunk(
  "emailApproval/approveFromEmail",
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await get(
        `authn/post/approval/status/${token}`,
        { skipAuth: true }
      );

      // ✅ return raw API response
      return response;
    } catch (error) {
      console.error("Approval API Error:", error);

      return rejectWithValue({
        message:
          error?.message ||
          "Something went wrong. Please try again later.",
      });
    }
  }
);

/**
 * ================================
 * INITIAL STATE
 * ================================
 */
const initialState = {
  approveStatus: "idle",   // idle | loading | succeeded | failed
  approveError: null,
  approveData: null,
};

/**
 * ================================
 * SLICE
 * ================================
 */
const emailApprovalSlice = createSlice({
  name: "emailApproval",
  initialState,
  reducers: {
    clearApprovalError: (state) => {
      state.approveError = null;
    },
    resetApprovalState: (state) => {
      state.approveStatus = "idle";
      state.approveError = null;
      state.approveData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(approveFromEmail.pending, (state) => {
        state.approveStatus = "loading";
        state.approveError = null;
      })
      .addCase(approveFromEmail.fulfilled, (state, action) => {
        state.approveStatus = "succeeded";
        state.approveData = action.payload;
      })
      .addCase(approveFromEmail.rejected, (state, action) => {
        state.approveStatus = "failed";
        state.approveError = action.payload;
        state.approveData = null;
      });
  },
});

/**
 * ================================
 * EXPORTS
 * ================================
 */
export const {
  clearApprovalError,
  resetApprovalState,
} = emailApprovalSlice.actions;

export default emailApprovalSlice.reducer;